import { IS_FETCHING, DONE_FETCHING } from './actions'

const initialState = {
  isFetching: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_FETCHING: {
      return {
        ...state,
        isFetching: [...state.isFetching, action.payload]
      }
    }
    case DONE_FETCHING: {
      return {
        ...state,
        isFetching: state.isFetching.filter(
          (fetching) => fetching !== action.payload
        )
      }
    }
    default:
      return state
  }
}

export default reducer
